import React, { Component } from 'react'
import { connect } from "react-redux";
import Grid from "../../../components/grid";
import { getSaleOrders } from "../../../store/actions";
import EditUser from "./edit";
import AddOrder from "./add";
import AddIcon from '../../../assets/images/ionic-ios-add-circle-outline.png';
import CheckboxRenderer from '../../../components/grid/CheckboxRenderer';
import { format } from 'date-fns';
class SaleOrdersView extends Component {
  state = {
    loading: false,
    selectedRowData: "",
    isShow: false,
    showOrderDetails: false,
    columnDefs: [
      {
        headerName: "Sale ID",
        field: "saleId",
        resizable: true,
        width: 150,
        flex: 1,
      }, {
        headerName: "Order Date",
        field: "orderDate",
        resizable: true,
        width: 150,
        flex: 1,
        filter: false,
        valueFormatter: params => params.value ? format(new Date(params.value), 'MMM dd yyyy') : "",
      },
      {
        headerName: "Billing Date",
        field: "billingDate",
        resizable: true,
        width: 150,
        filter: false,
        valueFormatter: params => params.value ? format(new Date(params.value), 'MMM dd yyyy') : "",

      },
      {
        headerName: "Total Price",
        field: "totalPrice",
        resizable: true,
        width: 100,
        flex: 1,
        filter: false,
      },

      {
        headerName: "Client",
        field: "company.companyShortName",
        resizable: true,
        width: 150,
        flex: 1,
        filter: true,
      },
      {
        headerName: "Billed",
        field: "isBilled",
        resizable: true,
        flex: 1,
        width: 150,
        filter: false,
        cellRenderer: function (params) {
          if (params.value !== undefined) {
            if (params.value) {
              return `<div className="ag-grid-checkbox">
        <input className="styled-checkbox" readonly  type="checkbox" checked>
        <label></label>
      </div>`;
            } else {
              return `<div className="ag-grid-checkbox">
        <input className="styled-checkbox" readonly  type="checkbox" >
        <label ></label>
      </div>`;
            }
          }

        },
      },

    ],
    rowData: [],
    searchText: '',
  };

  async componentDidMount() {
    await this.props.getSaleOrders();
    this.setState({ rowData: this.props.SALE_ORDERS });
  };

  async componentDidUpdate(prevProps, prevState) {
    if (!prevProps.SALE_ORDERS?.length && this.props.SALE_ORDERS?.length) this.setState({ rowData: this.props.SALE_ORDERS });
  };

  frameworkComponents = {
    CheckboxRenderer: CheckboxRenderer
  };

  onGridReady = params => {
    params.api.addGlobalListener((type, e) => {
      if (type === "rowClicked") {
        this.EditOrder(e.data);
      }
    })
    /* 
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        let dataSource = {
          getRows: async (params) => {
            this.usersPayload.startRow = params.startRow;
            this.usersPayload.endRow = params.endRow;
            this.usersPayload.searchText = this.state.searchText;
            // use redux..
            this.gridApi.showLoadingOverlay();
            await this.props.getOutboundOrder(this.usersPayload);
            const getUsersList = this.props.OutboundOrderR;
            let companyList = []
            getUsersList['records']?.forEach(async element => {
              let findClient = companyList.records?.filter(res => res._id === element.clientInformation.clientId)
              element.clientInformation = findClient[0]?.companyName
              element.clientInformationId = findClient[0]?._id
              if (element.itemId?.hasOwnProperty('itemName')) {
                element.itemName = element.itemId['itemName']
              }
            });
            this.gridApi.hideOverlay();
            if (!getUsersList.records.length) {
              this.gridApi.showNoRowsOverlay();
            } else {
              this.setState({ rowData: getUsersList.records })
              return params.successCallback(getUsersList.records, getUsersList.count);
            }
          }
        }
        params.api.setDatasource(dataSource) */
  }

  searchInput = (e) => {
    this.setState({ searchText: e.target.value });
    this.gridApi.purgeInfiniteCache();
  }

  /* 
    refreshGrid = () => {
      this.gridApi.refreshInfiniteCache();
    } */

  EditOrder(event) {
    //await this.props.editClientData(event);
    //this.setState({ isShow: true });
    this.setState({ selectedRowData: event, isEdit: true, showOrderDetails: true })
  }

  closeSidebar = async () => {
    await this.props.getSaleOrders();
    this.setState({ isShow: false, showOrderDetails: false, isEdit: false, selectedRowData: "", });

    //this.refreshGrid()
  }

  AddOrder = () => {
    this.setState({ showOrderDetails: true });
  }

  render() {
    const { showOrderDetails, isShow, rowData } = this.state

    return (
      <>
        <div className="table-header d-flex align-items-center justify-content-between">
          <button className="add_order" onClick={this.AddOrder}><img src={AddIcon} /> Add </button>
        </div>
        <div className="shadow_white_box full-box mt-0">
          <div className="filter-list d-flex align-items-center justify-content-between">
            <div className="filter-field d-flex">
              <input type="text" placeholder="Search" autoComplete="off" onChange={(e) => this.searchInput(e)} />
            </div>
          </div>
          <div className="clients_grid">
            <Grid
              frameworkComponent={this.frameworkComponents}
              columnDefs={this.state.columnDefs}
              onGridReady={this.onGridReady}
              rowData={rowData}
              height='600px'
            >
            </Grid>
          </div>
        </div>
        {showOrderDetails && (<AddOrder
          isEdit={this.state.isEdit}
          orderData={this.state.selectedRowData}
          closeSidebar={this.closeSidebar} />)}
      </>
    )
  }
}

const mapStateToProps = ({ UserReducer, SaleOrdersReducer, }) => {
  let { SALE_ORDERS } = SaleOrdersReducer;
  return { UserReducer, SALE_ORDERS, };
};
export default connect(mapStateToProps, { getSaleOrders, })(SaleOrdersView);